import { createGlobalStyle } from 'styled-components';

export const SupportActivityBadgeStyle = createGlobalStyle`
  [data-testid='sidebar-support-activity'] p[data-testid='sidebar-support-activity-badge'] {
    background-color: ${({ theme }) => theme.colors.bg.primary} !important;
    padding: 2px 6px !important;
    border-radius: 9990px !important;
    font-size: 14px !important;
  }
`;
